import * as React from 'react';

export const SelfEvaluationTab = () => {
  return <div>TBA tab content: SelfEvaluationTab</div>;
};
